import React, { FC, useMemo } from 'react';
import AgentDashboard from './AgentDashboard';
import  {DashboardAdmin } from './DashboardAdmin'; 
import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import { Route } from 'react-router-dom';
import WallboardPage from '../../modules/apps/call/wallboard/WallboardPage';

const DashboardWrapper: FC = () => {
  const intl = useIntl();
  
  const auth = useMemo(() => {
    const rawAuth = localStorage.getItem('kt-auth-react-v');
    if (!rawAuth) return null;
    try {
        return JSON.parse(rawAuth);
    } catch (e) {
        return null;
    }
    }, []);

    const roles = auth?.roles || [];
    const isAgent = roles.includes("ROLE_AGENT");
    const isWallboard = roles.includes("ROLE_WALLBOARD");

    const renderDashboard = () => {
    
        if (isAgent) {
            return <AgentDashboard />;
        }else if(isWallboard) {
          return (
            <>
              <PageTitle>Wallboard</PageTitle>
              <WallboardPage />
            </>
          )
        }else{
            return <DashboardAdmin />;
        }

    };
  

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'MENU.DASHBOARD' })} 
      </PageTitle>
      
      <div className='dashboard-wrapper-container'>
        {renderDashboard()}
      </div>
    </>
  );
};

export { DashboardWrapper };